import type { ReactNode } from 'react';

/** A label/value grid: labels right-aligned in their own column, values beside them. */
export const DetailsGrid = ({ children }: { readonly children: ReactNode }) => <div className="details-grid">{children}</div>;

/**
 * One labelled value. A row whose value renders nothing is not shown at all (by CSS,
 * so it also catches a View component that renders nothing for an absent value): a
 * details pane leaves out what is not set rather than showing a dash for it. To say
 * something about an absent value instead, give the View component a `placeholder`.
 */
export const DetailsRow = ({ label, children }: { readonly label: string; readonly children?: ReactNode }) => (
  <div className="details-grid__row">
    <div className="details-grid__label">{label}</div>
    <div className="details-grid__value">{children}</div>
  </div>
);

/** A row without a label, spanning the grid: for a value best said as a sentence. */
export const DetailsSentence = ({ children }: { readonly children: ReactNode }) => <div className="details-grid__sentence">{children}</div>;
